"use client";

import { Box } from "@mui/material";

export function HeroVariant2() {
  return <Box>Hero Variant 2</Box>;
}
